import {FC, useState} from 'react'
import {createPortal} from 'react-dom'
import {Link} from 'react-router-dom'
import {SubmitHandler} from 'react-hook-form'
import queryString from 'query-string'
import {mapKeys, snakeCase} from 'lodash'
import {Healthcare, BlankTarget} from 'jbc-front/components/icons'
import Sidebar from 'jbc-front/components/Sidebar'
import {Modal} from 'jbc-front/components/presenters/ui/Modal'
import {useSelector} from 'hooks/redux'
import {useQuery} from '@apollo/client'
import {isFullAdminSelector} from 'libs/redux'
import {useBroadcastReloadHealthcareStatus} from '../useBroadcastReloadHealthcareStatus'
import {HEALTHCARE_STATUS, HealthcareStatusQueryResult} from './query'
import {Schema} from './schema'
import {ModalBody} from './ModalBody'
import styles from './HealthcareStartModal.scss'

export const HealthcareStartModal: FC = () => {
  const isFullAdmin = useSelector(isFullAdminSelector)
  const {data, refetch} = useQuery<HealthcareStatusQueryResult>(HEALTHCARE_STATUS, {fetchPolicy: 'no-cache'}) // 共通のエラー処理をスキップするため@apollo/clientのuseQueryを直接使用
  const [isModalOpen, setIsModalOpen] = useState(false)

  useBroadcastReloadHealthcareStatus(() => refetch())

  let showLink: 'none' | 'start' | 'open' = 'none'
  if (data?.healthcareStatus === 'NOT_STARTED' && isFullAdmin) {
    showLink = 'start'
  } else if (data?.healthcareStatus === 'HAS_ADMIN') {
    showLink = 'open'
  }

  const handleSubmit: SubmitHandler<Schema> = (data) => {
    setIsModalOpen(false)
    window.open(`/healthcare_start?${queryString.stringify(mapKeys(data, (_, k) => snakeCase(k)))}`, '_blank')
  }

  switch (showLink) {
    case 'start':
      return (
        <>
          <Sidebar.Item
            icon={Healthcare}
            rightIcon={BlankTarget}
            className="u-cur-pointer"
            onClick={() => setIsModalOpen(true)}
          >
            健康管理
          </Sidebar.Item>
          {createPortal(
            <Modal className={styles.modal} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
              <Modal.Header onClose={() => setIsModalOpen(false)}>ジョブカン健康管理を利用する</Modal.Header>
              <ModalBody onSubmit={handleSubmit} />
            </Modal>,
            document.body
          )}
        </>
      )
    case 'open':
      return (
        <Sidebar.Item icon={Healthcare} rightIcon={BlankTarget} as={Link} to="/healthcare_start" target="_blank">
          健康管理
        </Sidebar.Item>
      )
    case 'none':
      return null
  }
}
